import { put } from 'redux-saga/effects'
import { IPcr } from '../../../../pcr/store/pcr.types'
import { getSelectedDataFromObject } from '../../../../../utilities/data.util'
import { setRTSData } from '../store/revisedTraumaScore.actions'
import { initialRevisedTraumaScoreState } from '../store/revisedTraumaScore.reducers'

export function* getRTS(pcrDoc: IPcr) {
  let rtsPrNabcData = {}

  if (pcrDoc.prNabc) {
    const rtsPrNeuroKeys: any = Object.keys(initialRevisedTraumaScoreState)
    rtsPrNabcData = getSelectedDataFromObject(pcrDoc.prNabc, rtsPrNeuroKeys)
  }

  if (Object.keys(rtsPrNabcData).length !== 0) {
    yield put(setRTSData({ ...rtsPrNabcData }))
  }
}
